import { Select } from "antd";

export function AliasesInput({
  value,
  onChange,
  placeholder,
}: {
  value?: string[];
  onChange?: (v: string[]) => void;
  placeholder?: string;
}) {
  return (
    <Select
      mode="tags"
      style={{ width: "100%" }}
      tokenSeparators={[",", "，"]}
      value={value ?? []}
      onChange={onChange}
      placeholder={placeholder ?? "回车或逗号分隔，添加别名"}
    />
  );
}
